export default __webpack_public_path__ + "static/media/logo-us-Anthropologie.eec3eaeb.svg";